import React, { useMemo } from 'react';
import { DataGrid } from '@material-ui/data-grid';
import './PopupTemplates.scss';

/**
 * Split Layout Template - Left panel with table, right panel with chart
 * Used for popups that need a split view with header and side content
 */
const SplitLayoutTemplate = ({
  header,
  tableConfig,
  sideChart,
  pagination,
  onPaginationChange
}) => {
  const {
    rows = [],
    columns = [],
    totalElements = 0,
    gridProps = {}
  } = tableConfig || {};

  const gridHeight = useMemo(() => {
    const ROW_HEIGHT = 52;
    const HEADER_HEIGHT = 56;
    const FOOTER_HEIGHT = 56;
    const MAX_ROWS = 10;
    const rowCount = rows.length;
    const visibleRows = Math.min(rowCount, MAX_ROWS);
    return HEADER_HEIGHT + (visibleRows * ROW_HEIGHT) + FOOTER_HEIGHT;
  }, [rows.length]);

  const containerStyle = useMemo(() => ({
    height: gridHeight,
    width: '100%'
  }), [gridHeight]);

  const defaultGridProps = useMemo(
    () => ({
      disableSelectionOnClick: true,
      pagination: true,
      paginationMode: "server",
      rowsPerPageOptions: [5, 10, 20, 50, 100],
      disableColumnFilter: true,
      disableColumnSelector: true,
      disableColumnMenu: true,
      localeText: { noRowsLabel: "No Data Available" },
      sx: {
        minWidth: 1200,
        maxWidth: 2000,
        overflowY: "auto",
        "& .MuiDataGrid-virtualScroller": {
          overflowY: "auto",
        },
        "& .MuiDataGrid-cell": {
          display: "flex",
          alignItems: "center !important",
        },
        "& .MuiDataGrid-cellContent": {
          display: "flex",
          alignItems: "center !important",
          height: "100%",
        },
      },
      ...gridProps,
    }),
    [gridProps],
  );

  return (
    <div className="popup-content split-layout">
      {header}
      <div className="second-container">
        <div className="left-side-panel user">
          <div style={containerStyle}>
            <DataGrid
              rows={rows}
              columns={columns}
              rowCount={totalElements}
              page={pagination.page}
              pageSize={pagination.pageSize}
              onPageChange={(newPage) => onPaginationChange({ ...pagination, page: newPage })}
              onPageSizeChange={(newPageSize) => onPaginationChange({ ...pagination, pageSize: newPageSize })}
              {...defaultGridProps}
            />
          </div>
        </div>
        <div className="right-side-panel">
          <div className="secondary-title">
            Locations
          </div>
          <div>
            {sideChart}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplitLayoutTemplate;